import { getRoutersInfo } from '@/services/session';
import { historys } from '@/utils/history';
import { getRedPath } from '@/utils/utils';
import { Form, message, Modal, Select } from 'antd';
import React, { useEffect, useState } from 'react';
import { useModel } from 'umi';
import { identityList, uploadIdentity } from '../service';
import styles from './globalCom.less';

interface ApplyProps {
  visible: boolean;
  setVisible: (val: boolean) => void;
}

const Apply: React.FC<ApplyProps> = (props) => {
  const { visible, setVisible } = props;
  const [form] = Form.useForm();
  const { initialState, setInitialState } = useModel('@@initialState');

  const [list, setList] = useState<any>([]);
  const fetchUserInfo = async () => {
    const userInfo = await initialState?.fetchUserInfo?.();

    if (userInfo) {
      await setInitialState((s: any) => ({ ...s, currentUser: userInfo }));
    }
  };
  // 获取身份列表
  const getIndentityList = () => {
    identityList()
      .then((res) => {
        if (res.code === '00000') {
          setList(res.data);
          form.setFieldsValue({
            identityId: res.data?.[0]?.identityId,
          });
        } else {
          setList([]);
        }
      })
      .catch((err) => {
        console.error(err);
        setList([]);
      });
  };

  const modalOk = () => {
    form.submit();
  };
  const formOnFinish = ({ identityId }: any) => {
    if (identityId === undefined || identityId === null) return;
    uploadIdentity(identityId)
      .then(async (res) => {
        if (res.code === '00000') {
          message.success('修改成功');
          await fetchUserInfo();
          const menus = await getRoutersInfo();
          await setInitialState((s: any) => ({ ...s, menus }));
          const redirect = getRedPath(menus) || '/';
          setVisible(false);
          // 更新身份列表接口
          getIndentityList();
          historys.replace(redirect);
        } else {
          getIndentityList();
          // message.warning(res.msg);
        }
        form.resetFields();
      })
      .catch((err) => {
        form.resetFields();
        console.error(err);
      });
  };

  const modalCancel = () => {
    form.resetFields();
    setVisible(false);
  };

  useEffect(() => {
    getIndentityList();
  }, []);
  // console.log(initialState?.currentUser);

  return (
    <>
      <Modal
        className={styles.setModelForm}
        title={`切换身份（当前身份：${
          initialState?.currentUser?.curOrgId
            ? initialState?.currentUser?.curOrgName.length > 16
              ? initialState?.currentUser?.curOrgName?.slice(0, 16) + '...'
              : initialState?.currentUser?.curOrgName
            : '个人用户'
        }）`}
        destroyOnClose
        open={visible}
        // visible={visible}
        onOk={modalOk}
        onCancel={modalCancel}
      >
        <Form
          form={form}
          onFinish={formOnFinish}
          initialValues={{ identityId: list?.[0]?.identityId }}
        >
          <Form.Item label={''} name={'identityId'}>
            <Select placeholder="请选择">
              {list.map((ele: { identityName: string; identityId: number }) => (
                <Select.Option key={ele.identityId} value={ele.identityId}>
                  {ele.identityName}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

export default Apply;
